import createVueComponent from '../createVueComponent';

const Clock7 = createVueComponent('Clock7Icon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 9.5 16', key: 'ka3394' }],
]);

export default Clock7;
